var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { api } from 'network/network.ts';
function fromTourItemDto(rawItem) {
    return Object.assign(Object.assign({}, rawItem), { findCheapestTourVariant, variants: rawItem.variants.map(variant => (Object.assign(Object.assign({}, variant), { currency: rawItem.currency, 
            //calcTourPrice,
            priceVariants: variant.prices.map(price => (Object.assign(Object.assign({}, price), { accomodationVariants: price.accomodations.map(accmdVariant => (Object.assign(Object.assign({}, accmdVariant), { orderAvailability: accmdVariant.immediateConfirm ? "available" : "onRequest", checkInDate: new Date(accmdVariant.checkInDate), 
                    //duration: accmdVariant.duration,
                    currency: rawItem.currency }))) }))) }))) });
}
/**
 * Парсит json объект полученный в ответе из SearchTours и возвращает модели.
 */
export function parseSearchResult(response) {
    const resp = response;
    const tours = Array.from(resp.tours.map(x => fromTourItemDto(x)));
    return Object.assign(Object.assign({}, resp), { tours });
}
/**
 * Выполняет поиск туров и возвращает обработанную модель данных (пропущенную через
 * {@link parseSearchResult}).
 */
export function searchTours(query) {
    return __awaiter(this, void 0, void 0, function* () {
        const { response, errors } = yield api('get', '/Tour/SearchResult', query);
        return !errors ? parseSearchResult(response) : { errors };
    });
}
/**
 * Получает детальную информацию о туре.
 * @param tourVariantId Идентификатор варианта тура
 * @param accmmdVariantId Идентификатор варианта размещения
 */
export function fetchTourDetails(params) {
    return __awaiter(this, void 0, void 0, function* () {
        let q = 'tourVariantId' in params
            ? { variant: params.tourVariantId, accmmd: params.accmmdVariantId }
            : 'tourId' in params
                ? { tourId: params.tourId, hotelId: params.hotelId }
                : {};
        if (params.excursions)
            q['exc'] = params.excursions;
        if (params.externalFlight) {
            q['fId'] = params.externalFlight.flightId;
            q['fpId'] = params.externalFlight.providerId;
        }
        const { response, errors } = yield api('get', 'hash' in params ? `/Tour/HotelTourDescription/${params.hash}` : '/Tour/HotelTourDescription', q);
        return !errors ? response : { errors };
    });
}
/**
 * Получает детальную информацию о туре в корзине.
 * @param tourVariantId Идентификатор варианта тура
 * @param accmmdVariantId Идентификатор варианта размещения
 */
export function fetchTourDetailsFromCart() {
    return __awaiter(this, void 0, void 0, function* () {
        const { response, errors } = yield api('get', `/Cart/TourDescription/`, {});
        return !errors ? response : { errors };
    });
}
export function fetchExternalFlight(hash, externalFlight) {
    return __awaiter(this, void 0, void 0, function* () {
        const { response, errors } = yield api('get', `/Tour/flight/${hash}`, { aviacenterProviderId: externalFlight.providerId, aviacenterFlightId: externalFlight.flightId });
        return !errors ? response : { errors };
    });
}
export function fetchAdditionalFlights(hash, externalFlight) {
    return __awaiter(this, void 0, void 0, function* () {
        const { response, errors } = yield api('post', `/Tour/flights/additional/${hash}`, { aviacenterProviderId: externalFlight.providerId, aviacenterFlightId: externalFlight.flightId });
        return !errors ? response : { errors };
    });
}
/**
 * Возвращает описание варианта тура.
 */
export function fetchTourVariant(tourId, date, duration, adultCount, childAges, currentHash) {
    return __awaiter(this, void 0, void 0, function* () {
        const q = { tourId, date, duration, adultCount, childAges, currentHash };
        const { response, errors } = yield api('get', '/Tour/Variant', q);
        return !errors ? response : { errors };
    });
}
///**
// * Получает даты доступности тура.
// * @param tourVariantId Идентификатор варианта тура
// * @param month Месяц для которого запрашивать доступность. Может содержать любую дату/время месяца.
// * @param hotelId Идентификатор отеля для которого запрашивать доступность
// */
//export async function fetchTourAvailability(
//    tourId: number,
//    adultCount: number,
//    childAges: number[],
//    monthIso: string,
//    hotelId?: number): Promise<FetchTourAvailabilityResult>
//{
//    const q = { adultCount, childAges, month: monthIso, hotelId: hotelId };
//    const result = await api<TourAvailabilityDto[]>('get', '/Tour/' + tourId + '/Availability', q);
//    return !result.errors ? result.response : { errors: result.errors };
//}
/**
 * Получает приблизительные даты доступности тура. В результирующем списке могут присутствовать ложные даты.
 * @param tourId Идентификатор тура.
 * @param month Месяц для которого запрашивать доступность. Может содержать любую дату/время месяца.
 */
export function fetchTourAvailabilityApprox(tourId, monthIso) {
    return __awaiter(this, void 0, void 0, function* () {
        const q = { month: monthIso, tourId };
        const result = yield api('get', '/Tour/' + tourId + '/Availability', q);
        return !result.errors ? result.response : { errors: result.errors };
    });
}
/**
 * Получает доступные варианты размещения для для тура на указанную дату.
 */
export function fetchAccommodations(tourId, adultCount, childAges, dateIso, immediateConfirm, hotelIndex, hash) {
    return __awaiter(this, void 0, void 0, function* () {
        const q = { date: dateIso, tourId, adultCount, childAges, hotelIndex, immediateConfirm, hash };
        const result = yield api('get', '/Tour/Accommodations', q);
        return !result.errors ? result.response : { errors: result.errors };
    });
}
///**
// * Получает рекомендованые отели для тура.
// */
//export async function fetchHotelRecommendations(tourVariantId: string): Promise<FetchHotelRecommendationsResult> {
//    const q = { variant: tourVariantId };
//    const result = await api<TourHotelRecommendationDto[]>('get', '/Tour/HotelRecommendations', q);
//    return !result.errors ? result.response : { errors: result.errors };
//}
/**
 * Получает рекомендованые отели для тура.
 */
export function fetchHotelRecommendationsNew(tourVariantId, hash) {
    return __awaiter(this, void 0, void 0, function* () {
        const q = { variant: tourVariantId, hash };
        const result = yield api('get', '/Tour/HotelRecommendationsNew', q);
        return !result.errors ? result.response : { errors: result.errors };
    });
}
/**
 * Добавляет тур в корзину.
 * @returns Список ошибок или null, если операция прошла успешно.
 */
export function addTourToCart({ tourVariantId, accmdVariantIds, excursions, hash, externalFlight, extras, replaceExistingTour }) {
    return __awaiter(this, void 0, void 0, function* () {
        const { response: _, errors } = yield api('post', '/Tour/AddToCart', {
            tourVariantId,
            accomodationIds: accmdVariantIds,
            excursions,
            hash,
            flightId: externalFlight === null || externalFlight === void 0 ? void 0 : externalFlight.flightId,
            flightProviderId: externalFlight === null || externalFlight === void 0 ? void 0 : externalFlight.providerId,
            extras,
            replaceExistingTour
        });
        return errors;
    });
}
export function checkTourPrice(hash) {
    return __awaiter(this, void 0, void 0, function* () {
        const { response, errors } = yield api('post', '/Tour/CheckPrice', { hash });
        return !(response === null || response === void 0 ? void 0 : response.expired);
    });
}
function findCheapestTourVariant() {
    let cheapestVariant = null;
    let cheapestPriceItem = null;
    let minPrice = 0;
    // FIXME: в данный момент не учитываем существование сложных туров,
    // поэтому (корректная) реализация этого кейса закомментирована, для того
    // чтобы соотнести логику расчета цен на тур с текущей реализацией на бэке
    // где этот кейс не поддерживается.
    //
    // for (const tourVariant of this.variants) {
    //     const cheapestPerPeriod = tourVariant.accomodationPeriods
    //         .map(x => [x, x.findCheapestAccomodationVariant()] as const);
    //     const price = cheapestPerPeriod
    //         .reduce((acc, [_, variant]) => acc + (variant?.price ?? 0), 0);
    //     if (cheapestVariant == null || minPrice > price) {
    //         cheapestVariant = tourVariant;
    //         cheapestPeriods = cheapestPerPeriod;
    //         minPrice = price;
    //     }
    // }
    for (const tourVariant of this.variants) {
        const best = tourVariant.priceVariants.sort((a, b) => a.price - b.price)[0];
        const price = best.price;
        //const periods = tourVariant.priceVariants.length ? tourVariant.priceVariants : [];
        //const cheapestPerPeriod = periods
        //    .map(x => [x, x.findCheapestAccomodationVariantPrice()] as const);
        //const price = cheapestPerPeriod
        //    .reduce((acc, [_, variant]) => acc + (variant?.price ?? 0), 0);
        if (cheapestVariant == null || cheapestPriceItem == null || minPrice > price) {
            cheapestVariant = tourVariant;
            cheapestPriceItem = best;
            //cheapestPeriods = cheapestPerPeriod.length > 0 ? cheapestPerPeriod : null;
            minPrice = price;
        }
    }
    return cheapestVariant != null ? [cheapestVariant, cheapestPriceItem] : null;
}
